import React, { useCallback, useState, createContext, useContext } from 'react';
import { translations } from './translations';
type Lang = 'es' | 'en';
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('es');
  const t = useCallback((key: string) => {
    // @ts-ignore
    return translations[lang][key] || key;
  }, [lang]);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-124">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}